// @flow
/* eslint-env jest */
import { createStore, combineReducers } from 'redux';

const ERROR_MESSAGE_FIXTURE = 'Error Message';

const generateActions = (action: string) => ({
  [`${action}Pending`]: () => state => ({
    ...state,
    loading: true,
    errorMessage: '',
  }),
  [`${action}Success`]: response => state => ({
    ...state,
    [`${action}Response`]: response,
    loading: false,
    errorMessage: '',
  }),
  [`${action}Failure`]: errorMessage => state => ({
    ...state,
    errorMessage,
    loading: false,
  }),
});

export const generateActionTests = (
  action: string,
  responseFixture: any,
  actions: any,
  options: any,
  reducer: any
) => {
  describe(action, () => {
    let dispatch;
    let getState;

    beforeEach(() => {
      ({ dispatch, getState } = createStore(combineReducers({ test: reducer })));
    });

    it(`sets ${action}Pending state`, () => {
      expect(getState().test.loading).toBe(options.initialState.loading);
      dispatch(actions[`${action}Pending`]());
      expect(getState().test.loading).toBe(true);
    });

    it(`sets ${action}Failure state`, () => {
      expect(getState().test.errorMessage).toBe(options.initialState.errorMessage);
      dispatch(actions[`${action}Failure`](ERROR_MESSAGE_FIXTURE));
      expect(getState().test.errorMessage).toBe(ERROR_MESSAGE_FIXTURE);
    });

    it(`sets ${action}Success state`, () => {
      expect(getState().test[`${action}Response`]).toEqual(
        options.initialState[`${action}Response`]
      );
      dispatch(actions[`${action}Success`](responseFixture));
      expect(getState().test[`${action}Response`]).toEqual(responseFixture);
    });
  });
};

export default generateActions;



// WEBPACK FOOTER //
// ../react-lib/src/redux/ducks/generateActions.js